import { render, staticRenderFns } from "./b42.vue?vue&type=template&id=53e9f466&scoped=true"
import script from "./b42.vue?vue&type=script&lang=js"
export * from "./b42.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9f466",
  null
  
)

export default component.exports